<template>
    <div class="col s6 offset-s3 unsubscribe">
        <div class="center-align">
            <img src="@/assets/images/unsubscribe.svg" alt="Cancelar Inscrição" srcset="">
            <div
                class="col xl12"
                style="margin-top: 60px;     
                font-size: 24px;
                color: #a5a5a5;
                margin-bottom: 60px"
            >
                {{ message }}
            </div>

            <eg-button style="margin-bottom: 100px" @click="goToLandingPage">Ir para a página principal</eg-button>
        </div>
    </div>
</template>

<script>
import { addToBlacklistMarketing } from '@/services';
export default {
    name: 'UnsubscribeMarketing',
    data: () => ({
        message: ''
    }),
    async created() {
        try {
            const { email } = this.$route.query;
            const data = { email: email };
            await addToBlacklistMarketing(data);
            this.message = 'Você foi removido das nossas listas de e-mails.';
        } catch (e) {
            this.message = 'E-mail não encontrado';
            console.error(e);
        }
    },
    methods: {
        goToLandingPage() {
            this.$router.push({ path: '/' });
        }
    }
};
</script>
<style lang="scss" scoped>
.unsubscribe {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    img {
        max-width: 250px;
        width: 100%;
    }
}
</style>
